module.exports = __webpack_public_path__ + "img/scythe-stone.c8ed2100.svg";